/**
 * When adding new icons, in order to guarantee a full control on it -
 * please make sure to drop "width", "height", and "fill" properties.
 *
 * Icon name should follow naming convention in Figma.
 * @example:
 * Star.svg in Figma
 * star.svg in iconList
 *
 * @example:
 * StarFill.svg in Figma
 * star-fill.svg in iconList
 */
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { ReactComponent as Schedule } from '../../assets/icons/schedule.svg';
import { ReactComponent as CreateIncident } from '../../assets/icons/create-an-incident.svg';
import { ReactComponent as LineDot } from '../../assets/icons/line-dot.svg';
import { ReactComponent as StringCase } from '../../assets/icons/string-case.svg';
import { ReactComponent as DateRangePickerIcon } from '../../assets/icons/date-range-picker.svg';
import { ReactComponent as TriangleExclamationSolid } from '../../assets/icons/triangle-exclamation-solid.svg';
import { ReactComponent as TriangleExclamationOutline } from '../../assets/icons/triangle-exclamation-outline.svg';
import { ReactComponent as BarLabels } from '../../assets/icons/bar-labels.svg';
import { ReactComponent as Braze } from '../../assets/icons/braze.svg';
import { ReactComponent as FormulaCohort } from '../../assets/icons/formula-cohort.svg';
import { ReactComponent as FormulaPrediction } from '../../assets/icons/formula-prediction.svg';
import { ReactComponent as AscendingButton } from '../../assets/icons/ascending-button.svg';
import { ReactComponent as DescendingButton } from '../../assets/icons/descending-button.svg';
import { ReactComponent as Locked } from '../../assets/icons/locked.svg';
import { ReactComponent as Unlocked } from '../../assets/icons/unlocked.svg';
import { ReactComponent as Workspace } from '../../assets/icons/workspace.svg';
import { ReactComponent as Incidents } from '../../assets/icons/incidents.svg';
import { ReactComponent as Settings } from '../../assets/icons/settings.svg';
import { ReactComponent as Refresh } from '../../assets/icons/refresh.svg';
import { ReactComponent as CopySql } from '../../assets/icons/copy-sql.svg';
import { ReactComponent as ExportToCsv } from '../../assets/icons/export-to-csv.svg';
import { ReactComponent as ExportToJupyter } from '../../assets/icons/export-to-jupyter.svg';
import { ReactComponent as BackIcon } from '../../assets/icons/back-icon.svg';
import { ReactComponent as YAxis } from '../../assets/icons/y-axis.svg';
import { ReactComponent as SaveChartPref } from '../../assets/icons/save-chart-pref.svg';
import { ReactComponent as AddToDashboard } from '../../assets/icons/add-to-dashboard.svg';
import { ReactComponent as PathArrowRight } from '../../assets/icons/path-arrow-right.svg';
import { ReactComponent as ExportToPdf } from '../../assets/icons/export-to-pdf.svg';
import { ReactComponent as Filter } from '../../assets/icons/filter.svg';
import { ReactComponent as FilterAdd } from '../../assets/icons/filter-add.svg';
import { ReactComponent as RollingIcon } from '../../assets/icons/rolling-icon.svg';
import { ReactComponent as SortAscendingOrder } from '../../assets/icons/sort-ascending-order.svg';
import { ReactComponent as SortDescendingOrder } from '../../assets/icons/sort-descending-order.svg';
import { ReactComponent as SortDefaultOrder } from '../../assets/icons/sort-default-order.svg';
import { ReactComponent as ChartBarIcon } from '../../assets/icons/chart-bar-icon.svg';
import { ReactComponent as ChartMetricIcon } from '../../assets/icons/chart-metric-icon.svg';
import { ReactComponent as ChartPercentageAreaIcon } from '../../assets/icons/chart-percentage-area-icon.svg';
import { ReactComponent as ChartPredictionIcon } from '../../assets/icons/chart-prediction-icon.svg';
import { ReactComponent as ChartStackedColumnIcon } from '../../assets/icons/chart-stacked-column-icon.svg';
import { ReactComponent as Histogram } from '../../assets/icons/histogram.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ReactComponent as CameraIcon } from '../../assets/icons/camera-icon.svg';
import { ReactComponent as ExpandBinning } from '../../assets/icons/expand-binning.svg';
import { ReactComponent as LegendPath0 } from '../../assets/icons/legend-path-0.svg';
import { ReactComponent as LegendPath1 } from '../../assets/icons/legend-path-1.svg';
import { ReactComponent as Pause } from '../../assets/icons/pause.svg';
import { ReactComponent as Enable } from '../../assets/icons/enable.svg';
import { ReactComponent as Disable } from '../../assets/icons/disable.svg';
import { ReactComponent as IncidentHoliday } from '../../assets/icons/incident-holiday.svg';
import { ReactComponent as IncidentRelease } from '../../assets/icons/incident-release.svg';
import { ReactComponent as IncidentOperations } from '../../assets/icons/incident-operations.svg';
import { ReactComponent as IncidentUserAcquisition } from '../../assets/icons/incident-user-acquisition.svg';
import { ReactComponent as IncidentMarketing } from '../../assets/icons/incident-marketing.svg';
import { ReactComponent as IncidentOutages } from '../../assets/icons/incident-outages.svg';
import { ReactComponent as IncidentOther } from '../../assets/icons/incident-other.svg';
import { ReactComponent as Today } from '../../assets/icons/today.svg';
import { ReactComponent as Yesterday } from '../../assets/icons/yesterday.svg';
import { ReactComponent as ErrorIcon } from '../../assets/icons/error-icon.svg';
import { ReactComponent as PictureIcon } from '../../assets/icons/picture-icon.svg';
import { ReactComponent as MeasureFilter } from '../../assets/icons/measure-filter.svg';
import { ReactComponent as MeasureSelector } from '../../assets/icons/measure-selector.svg';
import { ReactComponent as Calendar } from '../../assets/icons/calendar.svg';
import { ReactComponent as Eye } from '../../assets/icons/eye.svg';
import { ReactComponent as Report } from '../../assets/icons/report.svg';
import { ReactComponent as RollingControlAverage } from '../../assets/icons/rolling-control-average.svg';
import { ReactComponent as RollingControlSum } from '../../assets/icons/rolling-control-sum.svg';
import { ReactComponent as OperandField } from '../../assets/icons/operand-field.svg';
import { ReactComponent as OperandValue } from '../../assets/icons/operand-value.svg';
import { ReactComponent as RollingControlWindow } from '../../assets/icons/rolling-control-window.svg';
import { ReactComponent as TableSortAsc } from '../../assets/icons/table-sort-asc.svg';
import { ReactComponent as TableSortDesc } from '../../assets/icons/table-sort-desc.svg';
import { ReactComponent as Documentation } from '../../assets/icons/documentation.svg';
import { ReactComponent as Integrations } from '../../assets/icons/integrations.svg';
import { ReactComponent as System } from '../../assets/icons/system.svg';
import { ReactComponent as CompareUp } from '../../assets/icons/compare-up.svg';
import { ReactComponent as CompareDown } from '../../assets/icons/compare-down.svg';
import { ReactComponent as ChartTableIcon } from '../../assets/icons/chart-table-icon.svg';
import { ReactComponent as AddMeasureIcon } from '../../assets/icons/add-measure-icon.svg';
import { ReactComponent as DataTableHorizontalBar } from '../../assets/icons/data-table-horizontal-bar.svg';
import { ReactComponent as ColoredOrangeCircles } from '../../assets/icons/colored-orange-circles.svg';
import { ReactComponent as ColoredWhiteCircles } from '../../assets/icons/colored-white-circles.svg';
import { ReactComponent as TableExpand } from '../../assets/icons/table-expand.svg';
import { ReactComponent as TableCollapse } from '../../assets/icons/table-collapse.svg';
import { ReactComponent as EntityEnable } from '../../assets/icons/entity-enable.svg';
import { ReactComponent as EntityDisable } from '../../assets/icons/entity-disable.svg';
import { ReactComponent as NavCollapse } from '../../assets/icons/nav-collapse.svg';
import { ReactComponent as NavExpand } from '../../assets/icons/nav-expand.svg';
import { ReactComponent as EsBasicEvent } from '../../assets/icons/entity-selection/basic-event.svg';
import { ReactComponent as EsVirtualEvent } from '../../assets/icons/entity-selection/virtual-event.svg';
import { ReactComponent as EsCohort } from '../../assets/icons/entity-selection/cohort.svg';
import { ReactComponent as EsMeasure } from '../../assets/icons/entity-selection/measure.svg';
import { ReactComponent as EsRangeBinning } from '../../assets/icons/entity-selection/range-binning.svg';
import { ReactComponent as EsEnumBinning } from '../../assets/icons/entity-selection/enum-binning.svg';
import { ReactComponent as DragDrop } from '../../assets/icons/drag-drop.svg';
import { ReactComponent as CohortFilter } from '../../assets/icons/cohort-filter.svg';
import { ReactComponent as GlobalFilter } from '../../assets/icons/global-filter.svg';
import { ReactComponent as ExpandEvent } from '../../assets/icons/expand-event.svg';
import { ReactComponent as FoldEvent } from '../../assets/icons/fold-event.svg';
import { ReactComponent as MergeEvent } from '../../assets/icons/merge-event.svg';
import { ReactComponent as Breakdown } from '../../assets/icons/breakdown.svg';
import { ReactComponent as ExpandEventActive } from '../../assets/icons/expand-event-active.svg';
import { ReactComponent as FoldEventActive } from '../../assets/icons/fold-event-active.svg';
import { ReactComponent as MergeEventActive } from '../../assets/icons/merge-event-active.svg';
import { ReactComponent as Play } from '../../assets/icons/play.svg';
import { ReactComponent as Checkmark } from '../../assets/icons/checkmark.svg';
import { ReactComponent as Minus } from '../../assets/icons/minus.svg';
import { ReactComponent as Circle } from '../../assets/icons/cicrle.svg';
import { ReactComponent as NamedCohort } from '../../assets/icons/named-cohort.svg';
import { ReactComponent as CohortInspect } from '../../assets/icons/cohort-inspect.svg';
import { ReactComponent as HorizontalBar } from '../../assets/icons/horizontal-bar.svg';
import { ReactComponent as Field } from '../../assets/icons/field.svg';
import { ReactComponent as NamedFilter } from '../../assets/icons/named-filter.svg';
import { ReactComponent as Pin } from '../../assets/icons/pin.svg';
import { ReactComponent as RteBold } from '../../assets/icons/rte/bold.svg';
import { ReactComponent as RteH1 } from '../../assets/icons/rte/h1.svg';
import { ReactComponent as RteH2 } from '../../assets/icons/rte/h2.svg';
import { ReactComponent as RteH3 } from '../../assets/icons/rte/h3.svg';
import { ReactComponent as RteBulletList } from '../../assets/icons/rte/bullet-list.svg';
import { ReactComponent as RteCenterAlign } from '../../assets/icons/rte/center-align.svg';
import { ReactComponent as RteClearFormat } from '../../assets/icons/rte/clear-format.svg';
import { ReactComponent as RteFontDecrease } from '../../assets/icons/rte/font-decrease.svg';
import { ReactComponent as RteFontIncrease } from '../../assets/icons/rte/font-increase.svg';
import { ReactComponent as RteHighlight } from '../../assets/icons/rte/highlight.svg';
import { ReactComponent as RteHorizontalLine } from '../../assets/icons/rte/horizontal-line.svg';
import { ReactComponent as RteIndent } from '../../assets/icons/rte/indent.svg';
import { ReactComponent as RteItalic } from '../../assets/icons/rte/italic.svg';
import { ReactComponent as RteLeftAlign } from '../../assets/icons/rte/left-align.svg';
import { ReactComponent as RteLink } from '../../assets/icons/rte/link.svg';
import { ReactComponent as RteNumberList } from '../../assets/icons/rte/number-list.svg';
import { ReactComponent as RteOutdent } from '../../assets/icons/rte/outdent.svg';
import { ReactComponent as RteRightAlign } from '../../assets/icons/rte/right-align.svg';
import { ReactComponent as RteUnderline } from '../../assets/icons/rte/underline.svg';
import { ReactComponent as RteUnlink } from '../../assets/icons/rte/unlink.svg';
import { ReactComponent as RteReturn } from '../../assets/icons/rte/return.svg';
import { ReactComponent as Text } from '../../assets/icons/text.svg';
import { ReactComponent as AddVirtualColumn } from '../../assets/icons/add-virtual-column.svg';
import { ReactComponent as Image } from '../../assets/icons/image.svg';
import { ReactComponent as EsJson } from '../../assets/icons/entity-selection/nf-json.svg';
import { ReactComponent as EsArrayObject } from '../../assets/icons/entity-selection/nf-array-object.svg';
import { ReactComponent as Duplicate } from '../../assets/icons/duplicate.svg';
import { ReactComponent as Folder } from '../../assets/icons/folder.svg';
import { ReactComponent as FolderMinus } from '../../assets/icons/folder-minus.svg';
import { ReactComponent as FolderPlus } from '../../assets/icons/folder-plus.svg';
import { ReactComponent as PlusCircle } from '../../assets/icons/plus-circle.svg';
import { ReactComponent as CircleUsers } from '../../assets/icons/circle-users.svg';
import { ReactComponent as StarCrossed } from '../../assets/icons/star-crossed.svg';
import { ReactComponent as Table } from '../../assets/icons/table.svg';
import { ReactComponent as TableCdw } from '../../assets/icons/table-cdw.svg';
import { ReactComponent as History } from '../../assets/icons/history.svg';
import { ReactComponent as CreateCohort } from '../../assets/icons/create-cohort.svg';
import { ReactComponent as Jupyter } from '../../assets/icons/jupyter.svg';
import { ReactComponent as ChartGeoMap } from '../../assets/icons/chart-geo-map.svg';
import { ReactComponent as CircleCheck } from '../../assets/icons/circle-check.svg';
import { ReactComponent as Users } from '../../assets/icons/users.svg';
import { ReactComponent as DictionaryNoResults } from '../../assets/icons/dictionary-no-results.svg';
import { ReactComponent as ArrowUpRight } from '../../assets/icons/arrow-up-right.svg';
import { ReactComponent as Rename } from '../../assets/icons/rename.svg';
import { ReactComponent as SaveChanges } from '../../assets/icons/save-changes.svg';
import { ReactComponent as Star } from '../../assets/icons/star.svg';
import { ReactComponent as StarFill } from '../../assets/icons/star-fill.svg';
import { ReactComponent as ChartLine } from '../../assets/icons/chart-line.svg';
import { ReactComponent as Funnel } from '../../assets/icons/funnel.svg';
import { ReactComponent as Dashboard } from '../../assets/icons/dashboard.svg';
import { ReactComponent as Path } from '../../assets/icons/path.svg';
import { ReactComponent as Retention } from '../../assets/icons/retention.svg';
import { ReactComponent as Significance } from '../../assets/icons/significance.svg';
import { ReactComponent as HandPointing } from '../../assets/icons/hand-pointing.svg';
import { ReactComponent as Trash } from '../../assets/icons/trash.svg';
import { ReactComponent as Pencil } from '../../assets/icons/pencil.svg';
import { ReactComponent as Envelope } from '../../assets/icons/envelope.svg';
import { ReactComponent as Slack } from '../../assets/icons/slack.svg';
import { ReactComponent as TrendUp } from '../../assets/icons/trend-up.svg';
import { ReactComponent as ChartPie } from '../../assets/icons/chart-pie.svg';
import { ReactComponent as ChartDonut } from '../../assets/icons/chart-donut.svg';
import { ReactComponent as ChartLineUp } from '../../assets/icons/chart-line-up.svg';
import { ReactComponent as ChartBarHorizontal } from '../../assets/icons/chart-bar-horizontal.svg';
import { ReactComponent as Chat } from '../../assets/icons/chat.svg';
import { ReactComponent as ArrowCircleRight } from '../../assets/icons/arrow-circle-right.svg';
import { ReactComponent as ArrowCircleUpRight } from '../../assets/icons/arrow-circle-up-right.svg';
import { ReactComponent as ArrowFatRight } from '../../assets/icons/arrow-fat-right.svg';
import { ReactComponent as Monitor } from '../../assets/icons/monitor.svg';
import { ReactComponent as ArrowSquareOut } from '../../assets/icons/arrow-square-out.svg';
import { ReactComponent as Cursor } from '../../assets/icons/cursor.svg';
import { ReactComponent as ChatText } from '../../assets/icons/chat-text.svg';
import { ReactComponent as PlayFill } from '../../assets/icons/play-fill.svg';
import { ReactComponent as CaretUp } from '../../assets/icons/caret-up.svg';
import { ReactComponent as CaretDown } from '../../assets/icons/caret-down.svg';
import { ReactComponent as CaretRight } from '../../assets/icons/caret-right.svg';
import { ReactComponent as CaretLeft } from '../../assets/icons/caret-left.svg';
import { ReactComponent as CaretDownFill } from '../../assets/icons/caret-down-fill.svg';
import { ReactComponent as CaretRightFill } from '../../assets/icons/caret-right-fill.svg';
import { ReactComponent as CaretLeftFill } from '../../assets/icons/caret-left-fill.svg';
import { ReactComponent as FunctionX } from '../../assets/icons/function-x.svg';
import { ReactComponent as ChatRegular } from '../../assets/icons/chat-regular.svg';
import { ReactComponent as ArrowSquareUpRight } from '../../assets/icons/arrow-square-up-right.svg';
import { ReactComponent as Browser } from '../../assets/icons/browser.svg';
import { ReactComponent as Check } from '../../assets/icons/check.svg';
import { ReactComponent as CheckFat } from '../../assets/icons/check-fat.svg';
import { ReactComponent as CheckCircle } from '../../assets/icons/check-circle.svg';
import { ReactComponent as LinkRegular } from '../../assets/icons/link.svg';
import { ReactComponent as HouseLine } from '../../assets/icons/house-line.svg';
import { ReactComponent as Lightning } from '../../assets/icons/lightning.svg';
import { ReactComponent as Files } from '../../assets/icons/files.svg';
import { ReactComponent as UsersThree } from '../../assets/icons/users-three.svg';
import { ReactComponent as UserCircle } from '../../assets/icons/user-circle.svg';
import { ReactComponent as CalendarDot } from '../../assets/icons/calendar-dot.svg';
import { ReactComponent as SlackLogo } from '../../assets/icons/slack-logo.svg';
import { ReactComponent as Gear } from '../../assets/icons/gear.svg';
import { ReactComponent as DotsThreeOutlineVertical } from '../../assets/icons/dots-three-outline-vertical.svg';
import { ReactComponent as Lumos } from '../../assets/icons/lumos.svg';
import { ReactComponent as ClipboardText } from '../../assets/icons/clipboard-text.svg';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import { ReactComponent as GlobalSimple } from '../../assets/icons/global-simple.svg';
import { ReactComponent as Intersect } from '../../assets/icons/intersect.svg';
import { ReactComponent as MagnifyingGlass } from '../../assets/icons/magnifying-glass.svg';
import { ReactComponent as DatabaseGear } from '../../assets/icons/database-gear.svg';
import { ReactComponent as Question } from '../../assets/icons/question.svg';
import { ReactComponent as UserGear } from '../../assets/icons/user-gear.svg';
import { ReactComponent as SignOut } from '../../assets/icons/sign-out.svg';
import { ReactComponent as Notepad } from '../../assets/icons/notepad.svg';
import { ReactComponent as Database } from '../../assets/icons/database.svg';
import { ReactComponent as BookOpenText } from '../../assets/icons/book-open-text.svg';
import { ReactComponent as Hashtag } from '../../assets/icons/hashtag.svg';
import { ReactComponent as Percent } from '../../assets/icons/percent.svg';
import { ReactComponent as ArrowLeftBold } from '../../assets/icons/arrow-left-bold.svg';
import { ReactComponent as PlusSquareFill } from '../../assets/icons/plus-square-fill.svg';
import { ReactComponent as FolderOpen } from '../../assets/icons/folder-open.svg';
import { ReactComponent as IconX } from '../../assets/icons/icon-x.svg';
import { ReactComponent as IconXBold } from '../../assets/icons/icon-x-bold.svg';
import { ReactComponent as MonitorPlay } from '../../assets/icons/monitor-play.svg';
import { ReactComponent as ArrowCounterClockwise } from '../../assets/icons/arrow-counter-clockwise.svg';
import { ReactComponent as Note } from '../../assets/icons/note.svg';
import { ReactComponent as ShareNetwork } from '../../assets/icons/share-network.svg';
import { ReactComponent as ArrowLineDown } from '../../assets/icons/arrow-line-down.svg';
import { ReactComponent as Clock } from '../../assets/icons/clock.svg';
import { ReactComponent as ClockFill } from '../../assets/icons/clock-fill.svg';
import { ReactComponent as EyeSlash } from '../../assets/icons/eye-slash.svg';
import { ReactComponent as WarningCircle } from '../../assets/icons/warning-circle.svg';
import { ReactComponent as CornersIn } from '../../assets/icons/corners-in.svg';
import { ReactComponent as CornersOut } from '../../assets/icons/corners-out.svg';
import { ReactComponent as SquareSplitVertical } from '../../assets/icons/square-split-vertical.svg';
import { ReactComponent as SquareSplitVerticalBottom } from '../../assets/icons/square-split-vertical-bottom.svg';
import { ReactComponent as SquareSplitVerticalTop } from '../../assets/icons/square-split-vertical-top.svg';
import { ReactComponent as Domain } from '../../assets/icons/domain.svg';
import { ReactComponent as Disconnected } from '../../assets/icons/network-slash.svg';
import { ReactComponent as CodeRegular } from '../../assets/icons/code-regular.svg';
import { ReactComponent as ChatTeardrop } from '../../assets/icons/chat-teardrop.svg';
import { ReactComponent as DotOutlineFill } from '../../assets/icons/dot-outline-fill.svg';
import { ReactComponent as ArrowCircleUpFill } from '../../assets/icons/arrow-circle-up-fill.svg';
import { ReactComponent as Palette } from '../../assets/icons/palette.svg';
import { ReactComponent as FloppyDisk } from '../../assets/icons/floppy-disk.svg';
import { ReactComponent as IconAt } from '../../assets/icons/icon-at.svg';
import { ReactComponent as FolderDashed } from '../../assets/icons/folder-dashed.svg';
import { ReactComponent as FolderSimpleStar } from '../../assets/icons/folder-simple-star.svg';
import { ReactComponent as ImageSquare } from '../../assets/icons/image-square.svg';
import { ReactComponent as Lock } from '../../assets/icons/lock.svg';
import { ReactComponent as ArrowSquareDown } from '../../assets/icons/arrow-square-down.svg';
import { ReactComponent as AiLoading } from '../../assets/icons/ai-loading.svg';
import { ReactComponent as Smiley } from '../../assets/icons/smiley.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as IconXCircle } from '../../assets/icons/icon-x-circle.svg';
import { ReactComponent as SmileyReaction } from '../../assets/icons/smiley-reaction.svg';

export const iconList = {
  'add-to-dashboard': AddToDashboard,
  'add-measure-icon': AddMeasureIcon,
  'ai-loading': AiLoading,
  'arrow-right': ArrowRight,
  'arrow-square-down': ArrowSquareDown,
  back: BackIcon,
  camera: CameraIcon,
  'caret-up': CaretUp,
  'caret-down': CaretDown,
  'chart-bar-icon': ChartBarIcon,
  'chart-geo-map': ChartGeoMap,
  'chart-metric-icon': ChartMetricIcon,
  'chart-percentage-area-icon': ChartPercentageAreaIcon,
  'chart-prediction-icon': ChartPredictionIcon,
  'chart-stacked-column-icon': ChartStackedColumnIcon,
  'chart-table-icon': ChartTableIcon,
  checkmark: Checkmark,
  'cohort-inspect': CohortInspect,
  'named-cohort': NamedCohort,
  'compare-up': CompareUp,
  'compare-down': CompareDown,
  'create-incident': CreateIncident,
  'copy-sql': CopySql,
  'code-regular': CodeRegular,
  'data-table-horizontal-bar': DataTableHorizontalBar,
  'dictionary-no-results': DictionaryNoResults,
  documentation: Documentation,
  domain: Domain,
  'export-to-csv': ExportToCsv,
  'export-to-jupyter': ExportToJupyter,
  'export-to-pdf': ExportToPdf,
  incidents: Incidents,
  'incident-holiday': IncidentHoliday,
  'incident-release': IncidentRelease,
  'incident-operations': IncidentOperations,
  'incident-user-acquisition': IncidentUserAcquisition,
  'incident-marketing': IncidentMarketing,
  'incident-outages': IncidentOutages,
  'incident-other': IncidentOther,
  integrations: Integrations,
  'error-icon': ErrorIcon,
  'filter-add': FilterAdd,
  filter: Filter,
  'horizontal-bar': HorizontalBar,
  'legend-path-0': LegendPath0,
  'legend-path-1': LegendPath1,
  'line-dot': LineDot,
  'path-arrow-right': PathArrowRight,
  plus: Plus,
  refresh: Refresh,
  rename: Rename,
  report: Report,
  'rolling-icon': RollingIcon,
  'save-changes': SaveChanges,
  schedule: Schedule,
  settings: Settings,
  'date-range-picker': DateRangePickerIcon,
  histogram: Histogram,
  'triangle-exclamation': TriangleExclamationSolid,
  'triangle-exclamation-outline': TriangleExclamationOutline,
  'bar-labels': BarLabels,
  history: History,
  braze: Braze,
  'formula-cohort': FormulaCohort,
  'formula-prediction': FormulaPrediction,
  'save-chart-pref': SaveChartPref,
  'sort-ascending-order': SortAscendingOrder,
  'sort-descending-order': SortDescendingOrder,
  'sort-default-order': SortDefaultOrder,
  system: System,
  'ascending-button': AscendingButton,
  'descending-button': DescendingButton,
  'string-case': StringCase,
  locked: Locked,
  unlocked: Unlocked,
  workspace: Workspace,
  'y-axis': YAxis,
  'expand-binning': ExpandBinning,
  pause: Pause,
  enable: Enable,
  disable: Disable,
  today: Today,
  yesterday: Yesterday,
  'picture-icon': PictureIcon,
  'measure-filter': MeasureFilter,
  'measure-selector': MeasureSelector,
  'table-sort-asc': TableSortAsc,
  'table-sort-desc': TableSortDesc,
  calendar: Calendar,
  eye: Eye,
  'rolling-control-average': RollingControlAverage,
  'rolling-control-sum': RollingControlSum,
  'operand-field': OperandField,
  'operand-value': OperandValue,
  'rolling-control-window': RollingControlWindow,
  'colored-orange-circles': ColoredOrangeCircles,
  'colored-white-circles': ColoredWhiteCircles,
  'table-expand': TableExpand,
  'table-collapse': TableCollapse,
  'entity-enable': EntityEnable,
  'entity-disable': EntityDisable,
  'nav-collapse': NavCollapse,
  'nav-expand': NavExpand,
  'es-basic-event': EsBasicEvent,
  'es-virtual-event': EsVirtualEvent,
  'es-cohort': EsCohort,
  'es-measure': EsMeasure,
  'es-enum-binning': EsEnumBinning,
  'es-range-binning': EsRangeBinning,
  'drag-drop': DragDrop,
  'create-cohort': CreateCohort,
  'cohort-filter': CohortFilter,
  'global-filter': GlobalFilter,
  'expand-event': ExpandEvent,
  'fold-event': FoldEvent,
  'merge-event': MergeEvent,
  breakdown: Breakdown,
  'expand-event-active': ExpandEventActive,
  'fold-event-active': FoldEventActive,
  'merge-event-active': MergeEventActive,
  play: Play,
  minus: Minus,
  circle: Circle,
  'es-named-filter': NamedFilter,
  'es-field': Field,
  pin: Pin,
  'rte-bold': RteBold,
  'rte-bullet-list': RteBulletList,
  'rte-center-align': RteCenterAlign,
  'rte-clear-format': RteClearFormat,
  'rte-font-decrease': RteFontDecrease,
  'rte-font-increase': RteFontIncrease,
  'rte-highlight': RteHighlight,
  'rte-horizontal-line': RteHorizontalLine,
  'rte-indent': RteIndent,
  'rte-italic': RteItalic,
  'rte-left-align': RteLeftAlign,
  'rte-link': RteLink,
  'rte-number-list': RteNumberList,
  'rte-outdent': RteOutdent,
  'rte-right-align': RteRightAlign,
  'rte-underline': RteUnderline,
  'rte-unlink': RteUnlink,
  'rte-return': RteReturn,
  'rte-h1': RteH1,
  'rte-h2': RteH2,
  'rte-h3': RteH3,
  text: Text,
  'add-virtual-column': AddVirtualColumn,
  image: Image,
  'es-json': EsJson,
  'es-array-object': EsArrayObject,
  duplicate: Duplicate,
  folder: Folder,
  'folder-minus': FolderMinus,
  'folder-plus': FolderPlus,
  'plus-circle': PlusCircle,
  'circle-users': CircleUsers,
  'star-crossed': StarCrossed,
  table: Table,
  'table-cdw': TableCdw,
  jupyter: Jupyter,
  'circle-check': CircleCheck,
  users: Users,
  'arrow-up-right': ArrowUpRight,
  star: Star,
  'star-fill': StarFill,
  'chart-line': ChartLine,
  funnel: Funnel,
  dashboard: Dashboard,
  path: Path,
  retention: Retention,
  significance: Significance,
  'hand-pointing': HandPointing,
  'caret-right': CaretRight,
  'caret-left': CaretLeft,
  trash: Trash,
  pencil: Pencil,
  envelope: Envelope,
  slack: Slack,
  'trend-up': TrendUp,
  'chart-pie': ChartPie,
  'chart-donut': ChartDonut,
  'chart-line-up': ChartLineUp,
  'chart-bar-horizontal': ChartBarHorizontal,
  chat: Chat,
  'arrow-circle-right': ArrowCircleRight,
  'arrow-circle-up-right': ArrowCircleUpRight,
  'arrow-fat-right': ArrowFatRight,
  monitor: Monitor,
  'arrow-square-out': ArrowSquareOut,
  cursor: Cursor,
  'chat-text': ChatText,
  'play-fill': PlayFill,
  'caret-down-fill': CaretDownFill,
  'caret-right-fill': CaretRightFill,
  'caret-left-fill': CaretLeftFill,
  'function-x': FunctionX,
  'chat-regular': ChatRegular,
  'arrow-square-up-right': ArrowSquareUpRight,
  browser: Browser,
  check: Check,
  'check-fat': CheckFat,
  'check-circle': CheckCircle,
  'link-regular': LinkRegular,
  'house-line': HouseLine,
  lightning: Lightning,
  files: Files,
  'slack-logo': SlackLogo,
  gear: Gear,
  'dots-three-outline-vertical': DotsThreeOutlineVertical,
  lumos: Lumos,
  'clipboard-text': ClipboardText,
  'users-three': UsersThree,
  'user-circle': UserCircle,
  'calendar-dot': CalendarDot,
  info: Info,
  'global-simple': GlobalSimple,
  intersect: Intersect,
  'magnifying-glass': MagnifyingGlass,
  'database-gear': DatabaseGear,
  question: Question,
  'user-gear': UserGear,
  'sign-out': SignOut,
  notepad: Notepad,
  database: Database,
  'book-open-text': BookOpenText,
  hashtag: Hashtag,
  percent: Percent,
  'arrow-left-bold': ArrowLeftBold,
  'plus-square-fill': PlusSquareFill,
  'folder-open': FolderOpen,
  'icon-x': IconX,
  'icon-x-bold': IconXBold,
  'monitor-play': MonitorPlay,
  'arrow-counter-clockwise': ArrowCounterClockwise,
  note: Note,
  'share-network': ShareNetwork,
  'arrow-line-down': ArrowLineDown,
  clock: Clock,
  'clock-fill': ClockFill,
  'eye-slash': EyeSlash,
  'warning-circle': WarningCircle,
  'corners-in': CornersIn,
  'corners-out': CornersOut,
  'square-split-vertical': SquareSplitVertical,
  'square-split-vertical-bottom': SquareSplitVerticalBottom,
  'square-split-vertical-top': SquareSplitVerticalTop,
  disconnected: Disconnected,
  'chat-teardrop': ChatTeardrop,
  'dot-outline-fill': DotOutlineFill,
  'arrow-circle-up-fill': ArrowCircleUpFill,
  palette: Palette,
  'floppy-disk': FloppyDisk,
  'icon-at': IconAt,
  'folder-dashed': FolderDashed,
  'folder-simple-star': FolderSimpleStar,
  'image-square': ImageSquare,
  lock: Lock,
  smiley: Smiley,
  'arrow-left': ArrowLeft,
  'smiley-reaction': SmileyReaction,
  'icon-x-circle': IconXCircle,
};
